import { ChevronRight } from 'lucide-react';
import React, { useState } from 'react';

const Section = () => {
  const [pingTest, setPingTest] = useState(null);
  const [isTestingPing, setIsTestingPing] = useState(false);

  // Simulasi ping test
  const simulatePingTest = () => {
    setIsTestingPing(true);
    setPingTest(null);
    
    setTimeout(() => {
      const games = [
        { name: 'Valorant', ping: Math.floor(Math.random() * 10) + 5 },
        { name: 'Mobile Legends', ping: Math.floor(Math.random() * 8) + 3 },
        { name: 'CS2', ping: Math.floor(Math.random() * 12) + 8 },
        { name: 'PUBG Mobile', ping: Math.floor(Math.random() * 15) + 5 }
      ];
      setPingTest(games);
      setIsTestingPing(false);
    }, 3000);
};

return (
<section className="relative min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto text-center">
            {/* Glitch effect title */}
            <div className="mb-8 relative">
              <h1 className="text-4xl sm:text-6xl lg:text-8xl font-black mb-4 relative">
                <span className="bg-gradient-to-r from-cyan-400 via-blue-700 to-blue-500 bg-clip-text text-transparent animate-pulse">
                  Telnet Home
                </span>
                <br />
                <span className="text-white">
                  GAMING ZONE
                </span>
              </h1>
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 via-blue-700 to-blue-500 bg-clip-text text-transparent opacity-30 animate-ping">
                <h1 className="text-4xl sm:text-6xl lg:text-8xl font-black">
                  Telnet Home
                  <br />
                  GAMING ZONE
                </h1>
              </div>
            </div>
            
            <p className="text-xl sm:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
              Internet khusus gamer dengan <span className="text-cyan-400 font-semibold">ping ultra rendah</span>, 
              bandwidth dedicated, dan <span className="text-blue-660 font-semibold">server gaming optimized</span>
            </p>

            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
              <button className="group bg-gradient-to-r from-cyan-500 to-blue-800 hover:from-cyan-400 hover:to-blue-900 px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-cyan-500/25">
                <span className="flex items-center gap-2">
                  Mulai Gaming <ChevronRight className="group-hover:translate-x-2 transition-transform" />
                </span>
              </button>
              
              <button 
                onClick={simulatePingTest}
                disabled={isTestingPing}
                className="group border-2 border-blue-400 hover:bg-blue-300 hover:text-gray-900 px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105"
              >
                {isTestingPing ? 'Testing...' : 'Test Ping Sekarang'}
              </button>
            </div>

            {/* Ping Test Results */}
            {pingTest && (
              <div className="bg-gray-800/60 backdrop-blur-md rounded-2xl p-6 mx-auto max-w-2xl border border-cyan-500/30 animate-fade-in">
                <h3 className="text-2xl font-bold mb-4 text-cyan-400">Live Ping Test Results</h3>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                  {pingTest.map((game, index) => (
                    <div key={index} className="text-center p-4 bg-gray-700/50 rounded-lg border border-gray-600">
                      <div className="font-bold text-white">{game.name}</div>
                      <div className="text-2xl font-black text-green-400">{game.ping}ms</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </section>
  );
};
export default Section;